/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DueDaysTypeEnum } from './DueDaysTypeEnum';
import {
    DueDaysTypeEnumFromJSON,
    DueDaysTypeEnumFromJSONTyped,
    DueDaysTypeEnumToJSON,
} from './DueDaysTypeEnum';
import type { InterestCalculationMethodEnum } from './InterestCalculationMethodEnum';
import {
    InterestCalculationMethodEnumFromJSON,
    InterestCalculationMethodEnumFromJSONTyped,
    InterestCalculationMethodEnumToJSON,
} from './InterestCalculationMethodEnum';
import type { PaymentPeriodicityEnum } from './PaymentPeriodicityEnum';
import {
    PaymentPeriodicityEnumFromJSON,
    PaymentPeriodicityEnumFromJSONTyped,
    PaymentPeriodicityEnumToJSON,
} from './PaymentPeriodicityEnum';
import type { TemplateTypeEnum } from './TemplateTypeEnum';
import {
    TemplateTypeEnumFromJSON,
    TemplateTypeEnumFromJSONTyped,
    TemplateTypeEnumToJSON,
} from './TemplateTypeEnum';
import type { VariableInterestTypeEnum } from './VariableInterestTypeEnum';
import {
    VariableInterestTypeEnumFromJSON,
    VariableInterestTypeEnumFromJSONTyped,
    VariableInterestTypeEnumToJSON,
} from './VariableInterestTypeEnum';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface IssueCreate
 */
export interface IssueCreate {
    /**
     * 
     * @type {number}
     * @memberof IssueCreate
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof IssueCreate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IssueCreate
     */
    company: number;
    /**
     * count of bonds
     * @type {number}
     * @memberof IssueCreate
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof IssueCreate
     */
    nominalValue: number;
    /**
     * 
     * @type {string}
     * @memberof IssueCreate
     */
    interestRate: string;
    /**
     * 
     * @type {Date}
     * @memberof IssueCreate
     */
    issueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof IssueCreate
     */
    maturityDate: Date;
    /**
     * 
     * @type {InterestCalculationMethodEnum}
     * @memberof IssueCreate
     */
    interestCalculationMethod?: InterestCalculationMethodEnum;
    /**
     * 
     * @type {Date}
     * @memberof IssueCreate
     */
    interestStartDate: Date;
    /**
     * 
     * @type {number}
     * @memberof IssueCreate
     */
    zfillBondNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof IssueCreate
     */
    promotionBonus?: string;
    /**
     * 
     * @type {PaymentPeriodicityEnum}
     * @memberof IssueCreate
     */
    paymentPeriodicity: PaymentPeriodicityEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueCreate
     */
    isin: string;
    /**
     * 
     * @type {string}
     * @memberof IssueCreate
     */
    variableInterestRate?: string;
    /**
     * 
     * @type {VariableInterestTypeEnum}
     * @memberof IssueCreate
     */
    variableInterestType?: VariableInterestTypeEnum;
    /**
     * 
     * @type {TemplateTypeEnum}
     * @memberof IssueCreate
     */
    templateType: TemplateTypeEnum;
    /**
     * Number of days before/after end of period
     * @type {number}
     * @memberof IssueCreate
     */
    dueDays?: number;
    /**
     * Indicates if due date for each issue return is before or after end of period
     * @type {DueDaysTypeEnum}
     * @memberof IssueCreate
     */
    dueDaysType?: DueDaysTypeEnum;
}

/**
 * Check if a given object implements the IssueCreate interface.
 */
export function instanceOfIssueCreate(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    if (!('company' in value)) return false;
    if (!('totalAmount' in value)) return false;
    if (!('nominalValue' in value)) return false;
    if (!('interestRate' in value)) return false;
    if (!('issueDate' in value)) return false;
    if (!('maturityDate' in value)) return false;
    if (!('interestStartDate' in value)) return false;
    if (!('paymentPeriodicity' in value)) return false;
    if (!('isin' in value)) return false;
    if (!('templateType' in value)) return false;
    return true;
}

export function IssueCreateFromJSON(json: any): IssueCreate {
    return IssueCreateFromJSONTyped(json, false);
}

export function IssueCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'company': json['company'],
        'totalAmount': json['total_amount'],
        'nominalValue': json['nominal_value'],
        'interestRate': json['interest_rate'],
        'issueDate': (dayjs.tz(json['issue_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'maturityDate': (dayjs.tz(json['maturity_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'interestCalculationMethod': json['interest_calculation_method'] == null ? undefined : InterestCalculationMethodEnumFromJSON(json['interest_calculation_method']),
        'interestStartDate': (dayjs.tz(json['interest_start_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'zfillBondNumber': json['zfill_bond_number'] == null ? undefined : json['zfill_bond_number'],
        'promotionBonus': json['promotion_bonus'] == null ? undefined : json['promotion_bonus'],
        'paymentPeriodicity': PaymentPeriodicityEnumFromJSON(json['payment_periodicity']),
        'isin': json['isin'],
        'variableInterestRate': json['variable_interest_rate'] == null ? undefined : json['variable_interest_rate'],
        'variableInterestType': json['variable_interest_type'] == null ? undefined : VariableInterestTypeEnumFromJSON(json['variable_interest_type']),
        'templateType': TemplateTypeEnumFromJSON(json['template_type']),
        'dueDays': json['due_days'] == null ? undefined : json['due_days'],
        'dueDaysType': json['due_days_type'] == null ? undefined : DueDaysTypeEnumFromJSON(json['due_days_type']),
    };
}

export function IssueCreateToJSON(value?: IssueCreate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'company': value['company'],
        'total_amount': value['totalAmount'],
        'nominal_value': value['nominalValue'],
        'interest_rate': value['interestRate'],
        'issue_date': (dayjs(value['issueDate']).format('YYYY-MM-DD')),
        'maturity_date': (dayjs(value['maturityDate']).format('YYYY-MM-DD')),
        'interest_calculation_method': InterestCalculationMethodEnumToJSON(value['interestCalculationMethod']),
        'interest_start_date': (dayjs(value['interestStartDate']).format('YYYY-MM-DD')),
        'zfill_bond_number': value['zfillBondNumber'],
        'promotion_bonus': value['promotionBonus'],
        'payment_periodicity': PaymentPeriodicityEnumToJSON(value['paymentPeriodicity']),
        'isin': value['isin'],
        'variable_interest_rate': value['variableInterestRate'],
        'variable_interest_type': VariableInterestTypeEnumToJSON(value['variableInterestType']),
        'template_type': TemplateTypeEnumToJSON(value['templateType']),
        'due_days': value['dueDays'],
        'due_days_type': DueDaysTypeEnumToJSON(value['dueDaysType']),
    };
}

